<template>
  <div>
    个人中心
    <van-tabbar v-model="active">
      <van-tabbar-item icon="home-o" to="/">通知中心</van-tabbar-item>
      <van-tabbar-item icon="search" to="/mine/home">我的</van-tabbar-item>
      <!-- <van-tabbar-item icon="friends-o">标签</van-tabbar-item>
      <van-tabbar-item icon="setting-o">标签</van-tabbar-item> -->
    </van-tabbar>
  </div>
</template>
<script>
export default {
  data(){
    return{
      active: 1,
    }
  }
}
</script>
<style lang="scss" scoped>

</style>